export const UPDATE_MERCH_STATUS = '[Merch] Update Status';
export const UPDATE_MERCH_STATUS_SUCCESS = '[Merch] Update Status Success';

export const LIST_MERCH_CATALOG = '[Merch Catalog] List merch';
export const LIST_MERCH_CATALOG_SUCCESS = '[Merch Catalog] List merch Success';
export const LIST_MERCH_CATALOG_ERROR = '[Merch Catalog] List merch Error';

export const LIST_ARTIST_MERCH = '[Merch] List artist merch';
export const LIST_ARTIST_MERCH_SUCCESS = '[Merch] List artist merch Success';
export const LIST_ARTIST_MERCH_ERROR = '[Merch] List artist merch Error';

export const CREATE_MERCH = '[Merch] Create Merch';
export const CREATE_MERCH_SUCCESS = '[Merch] Create Merch Success';
export const CREATE_MERCH_ERROR = '[Merch] Create Merch Error';

export const CREATE_MERCH_DRAFT = '[Merch] Create Merch Draft';
export const CREATE_MERCH_DRAFT_SUCCESS = '[Merch] Create Merch Draft Success';
export const CREATE_MERCH_DRAFT_ERROR = '[Merch] Create Merch Draft Error';

export const EDIT_MERCH = '[Merch] Edit Merch';
export const EDIT_MERCH_SUCCESS = '[Merch] Edit Merch Success';
export const EDIT_MERCH_ERROR = '[Merch] Edit Merch Error';

export const UPDATE_MERCH = '[Merch] Update Merch';
export const UPDATE_MERCH_SUCCESS = '[Merch] Update Merch Success';
export const UPDATE_MERCH_ERROR = '[Merch] Update Merch Error';

export const UPDATE_MERCH_STORE = '[Merch] Update Merch Store';
export const UPDATE_MERCH_STORE_SUCCESS = '[Merch] Update Merch Store Success';
export const UPDATE_MERCH_STORE_ERROR = '[Merch] Update Merch Store Error';

export const CLEAN_MERCH_STORE = '[Merch] Clean Merch Store';
export const CLEAN_MERCH_STORE_SUCCESS = '[Merch] Clean Merch Store Success';
export const CLEAN_MERCH_STORE_ERROR = '[Merch] Clean Merch Store Error';

export const PUBLISH_PRODUCT = '[Merch] Publish Product';
export const PUBLISH_PRODUCT_SUCCESS = '[Merch] Publish Product Success';
export const PUBLISH_PRODUCT_ERROR = '[Merch] Publish Product Error';

export const DELETE_MERCH = '[Merch] Delete Merch';
export const DELETE_MERCH_SUCCESS = '[Merch] Delete Merch Success';
export const DELETE_MERCH_ERROR = '[Merch] Delete Merch Error';

export const GET_CATALOG_ITEM = '[Merch Item] Get Merch Item';
export const GET_CATALOG_ITEM_SUCCESS = '[Merch Item] Get Merch Item Success';
export const GET_CATALOG_ITEM_ERROR = '[Merch Item] Get Merch Item Error';

export const UPLOAD_MERCH_IMAGE = '[Merch Image] Upload Image';
export const UPLOAD_MERCH_IMAGE_SUCCESS = '[Merch Image] Upload Image Success';
export const UPLOAD_MERCH_IMAGE_ERROR = '[Merch Image] Upload Image Error';

export const EDIT_MERCH_IMAGE = '[Merch Image] Upload Image file';

export const UPDATE_MERCH_ORDER = '[Merch] Update Merch Order';
export const UPDATE_MERCH_ORDER_SUCCESS = '[Merch] Update Merch Order Success';
export const UPDATE_MERCH_ORDER_ERROR = '[Merch] Update Merch Order Error';

export const CHANGE_MERCH_DESIGN_POSITION =
  '[Merch] Update Merch Design Position';
export const CHANGE_MERCH_DESIGN_POSITION_SUCCESS =
  '[Merch] Update Merch Design Position Success';
export const CHANGE_MERCH_DESIGN_POSITION_ERROR =
  '[Merch] Update Merch Design Position Error';

export const REDIRECT_MERCH_SUCCESS_PAGE =
  '[Merch] Redirect Merch Success Page';
export const REDIRECT_TO_MERCH_PAGE = '[Merch] Redirect To Merch Page';
export const REDIRECT_TO_CATALOG_PAGE = '[Merch] Redirect To Catalog Page';
export const FINISH_MERCH_LATER = '[Merch] Finish Merch Later';
export const FINISH_MERCH_LATER_SUCCESS = '[Merch] Finish Merch Later Success';
export const FINISH_MERCH_LATER_ERROR = '[Merch] Finish Merch Later Error';

export const AUTO_SAVE_MERCH = '[Merch] Auto Save Merch';
export const AUTO_SAVE_MERCH_SUCCESS = '[Merch] Auto Save Merch Success';
export const AUTO_SAVE_MERCH_ERROR = '[Merch] Auto Save Merch Error';

export const CHANGE_MERCH_COLOR = '[Merch] Change Merch Color';
export const CHANGE_MERCH_COLOR_SUCCESS = '[Merch] Change Merch Color Success';
export const CHANGE_MERCH_COLOR_ERROR = '[Merch] Change Merch Color Error';

export const CHANGE_MERCH_TYPE = '[Merch] Change Merch Type';
export const CHANGE_MERCH_TYPE_SUCCESS = '[Merch] Change Merch Type Success';
export const CHANGE_MERCH_TYPE_ERROR = '[Merch] Change Merch Type Error';

export const UPDATE_MERCH_PRODUCT_ERROR = '[Merch] Update Merch Product Error';
export const UPDATE_MERCH_IMAGES = '[Merch] Update Merch Images';
export const UPDATE_MERCH_PRODUCT_POSITION = '[Merch] Update Product Position';

export const VALIDATE_MERCH_PRODUCT_SAMPLE_ORDER =
  '[Merch] Validate Sample Order';
export const VALIDATE_MERCH_PRODUCT_SAMPLE_ORDER_SUCCESS =
  '[Merch] Validate Sample Order Success';
export const VALIDATE_MERCH_PRODUCT_SAMPLE_ORDER_ERROR =
  '[Merch] Validate Sample Order Error';
export const UPDATE_MERCH_PRODUCT_SAMPLE_ORDER = '[Merch] Update Sample Order';
export const CREATE_MERCH_PRODUCT_SAMPLE_ORDER = '[Merch] CREATE Sample Order';
export const CREATE_MERCH_PRODUCT_SAMPLE_ORDER_SUCCESS =
  '[Merch] CREATE Sample Order Success';
export const CREATE_MERCH_PRODUCT_SAMPLE_ORDER_ERROR =
  '[Merch] CREATE Sample Order Error';
export const GET_MERCH_SAMPLE_ORDER_SHIPPING_COST =
  '[Merch] Get Sample Order Shipping Cost';
export const GET_MERCH_SAMPLE_ORDER_SHIPPING_COST_SUCCESS =
  '[Merch] Get Sample Order Shipping Cost Success';
export const GET_MERCH_SAMPLE_ORDER_SHIPPING_COST_ERROR =
  '[Merch] Get Sample Order Shipping Cost Error';

export const UPDATE_IS_NEW_MERCH = '[Merch] Update Is New Merch';
